import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IInputDateTImeField } from './model/IInputDateTImeField';
import { Calendar } from 'primeng/calendar';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-input-date-time-field-box',
  templateUrl: './input-date-time-field-box.component.html',
  styleUrls: ['./input-date-time-field-box.component.scss']
})
export class InputDateTimeFieldBoxComponent implements OnChanges {
  dateFormat: string = 'dd-M-yy';
  @Input() inputValue: any;
  @Input() fieldDetails: IInputDateTImeField = {
    lable: 'Date',
    placeholder: 'Enter Email',
    isTime: false,
    isServerError: true,
    serverErrorText: 'Email is required'
  };
  @Input() formSubmitted: boolean = false;
  @Output() outputKeyword: EventEmitter<string> = new EventEmitter();
  @Output() isValidation: EventEmitter<boolean> = new EventEmitter();

  constructor(private datePipe: DatePipe, private translate: TranslateService) {
    // Initialize the selectedDate with the current date or any other date.
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.inputValue && this.formatSelectedDate();
    // this.validationCheckFn();
  }

  translatorFn(value) {
    return this.translate.instant(value);
  }

  // validationCheckFn() {
  //   if (this.fieldDetails.isRequired) {
  //     !!this.inputValue ? this.isValidation.emit(true) : this.isValidation.emit(false)
  //   }
  // }

  formatSelectedDate(): any {
    this.inputValue = new Date(this.inputValue);
    if (isNaN(this.inputValue.getTime())) {
      return this.inputValue;
    }
    return this.datePipe.transform(this.inputValue, 'dd-M-yy');

  }

  onDateTimeSelect(data: any) {
    console.log(data);
    // this.validationCheckFn();
    // added by priya - 25/01/25
    if(this.fieldDetails.isTime == true){
      var dt = this.datePipe.transform(this.inputValue, 'dd-MMM-yyyy HH:mm:ss');
    } else {
      var dt = this.datePipe.transform(this.inputValue, 'dd-MMM-yyyy');
    }
    this.outputKeyword.emit(dt);
  }
}
